<template lang="pug">
.purchaseButtonsBlockComponent
  .col
    ui-button.button(
      size="xl"
      color="orange-hover"
      is-responsive
      @click="onPurchaseButtonClick"
    ) {{ buyButtonText }}
  .col
    template(v-if="showTryButton")
      template(v-if="!isLastSection")
        a.button(href="#purchase")
          ui-button(
            size="xl"
            is-responsive
            color="blue-outline-hover"
          ) Попробовать
      template(v-else)
        ui-button.button(
          size="xl"
          is-responsive
          color="blue-outline-hover"
          @click="onTryButtonClick"
        ) Попробовать бесплатно
        .hint Полный доступ на 5 дней
    template(v-else)
      ui-button.button(
        size="xl"
        is-responsive
        color="blue-outline-hover"
        @click="onTryButtonClick"
      ) Перейти в сервис
</template>

<script>
import { computed, inject } from 'vue'
import { useRouter } from 'vue-router'
import { LS_HOMEPAGE_WANTS_PURCHASE, LS_HOMEPAGE_WANTS_DEMO } from '@/config'
import PurchaseModal from '@/components/Homepage/PurchaseModal/PurchaseModal'
import LoginAlertModal from '@/components/Homepage/LoginAlertModal/LoginAlertModal'
import AppTutorial from '@/components/AppTutorial/AppTutorial'
import DemoModal from '@/components/Demo/DemoModal'

export default {
  props: {
    isLastSection: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const store = inject('store')
    const router = useRouter()
    const buyButtonText = computed(() => (props.isLastSection ? 'Купить предмет' : 'Купить'))

    const onPurchaseButtonClick = () => {
      if (store.user.isAuthenticated) {
        store.modalQueue.push({
          key: 'purchase',
          component: PurchaseModal
        })
      } else {
        localStorage.setItem(LS_HOMEPAGE_WANTS_PURCHASE, 1)
        store.modalQueue.push({
          key: 'login-alert',
          component: LoginAlertModal,
          props: {
            text: 'Для приобретения сервиса «Начинайзер» необходима авторизация'
          }
        })
      }
    }

    const onTryButtonClick = () => {
      if (store.user.isAuthenticated) {
        router.push({
          name: 'Catalog'
        })

        if (!store.user.profile.hasSubscriptions && (store.user.profile.subscription.isNone || store.user.profile.subscription.isOver)) {
          store.modalQueue.push({
            key: 'demo',
            component: DemoModal
          })
        } else if (store.user.profile.showTutorial) {
          store.modalQueue.push({
            key: 'apptutorial',
            component: AppTutorial
          })
        }
      } else {
        localStorage.setItem(LS_HOMEPAGE_WANTS_DEMO, 1)
        store.modalQueue.push({
          key: 'login-alert',
          component: LoginAlertModal,
          props: {
            text: 'Авторизуйтесь на сайте и получите пробный доступ к сервису «Начинайзер» на 5 дней'
          }
        })
      }
    }

    const showTryButton = computed(() => {
      return !store.user.isAuthenticated || (!store.user.profile.hasSubscriptions && (store.user.profile.subscription.isNone || store.user.profile.subscription.isOver))
    })

    return {
      onPurchaseButtonClick,
      onTryButtonClick,
      showTryButton,
      buyButtonText
    }
  }
}
</script>

<style lang="sass" scoped>
.purchaseButtonsBlockComponent
  display: flex
  margin-top: -5*$u
  margin-left: -5*$u
  @media (max-width: $XXSWidth)
    flex-wrap: wrap

  > .col
    width: 100%
    margin-top: 5*$u
    margin-left: 5*$u

    > .hint
      font-family: GolosTextWebRegular, serif
      font-style: normal
      font-weight: normal
      font-size: 14px
      line-height: 130%
      color: #847F7F
      margin-top: 3*$u
      text-align: center
</style>
